import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { QUERY_KEY_MAP, getPendingMaintenanceTasks } from 'src/constants';
import { getDeviceDetailsPromise } from 'src/utils/api/get-device-details';

const PENDING_TASK_POLL_INTERVAL = 1000 * 30;

export const useGetDeviceDetails = (custom_device_id?: string) => {
  const { deviceId } = useParams<{ deviceId: string }>();

  const deviceIdToPassOn = custom_device_id || deviceId;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetDeviceDetails, deviceIdToPassOn],
    queryFn: () => getDeviceDetailsPromise(deviceIdToPassOn as string),
    enabled: !!deviceIdToPassOn,
    // Poll until the device has picked up all queued maintenance tasks
    refetchInterval: (query) =>
      getPendingMaintenanceTasks(query.state.data?.maintenance_tasks).length ? PENDING_TASK_POLL_INTERVAL : false,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
